import levelSpecs from "../res/levels/*.json";
import playerSpecs from "../res/players/*.json";

const players = Object.keys(playerSpecs).sort();
const levels = Object.keys(levelSpecs).sort();

export default {
    namespaced: true,
    state: {
        players,
        levels,
        gameTypes: [1, 2, 3],
        difficulties: ["Easy", "Normal", "Hard"]
    }
};
